import { useNavigation } from '../../app/navigation';
import { routeChrome } from '../../app/labels';
import { useSession } from '../../state/session';
import { useGame } from '../../game/store';
import { creditWord, formatCredits } from '../../lib/format';
import { useFullscreen } from '../../lib/useFullscreen';
import { Avatar } from '../ui/Avatar';
import { Icon } from '../ui/Icon';
import { creditIconFor } from '../ui/currency';
import styles from './TopBar.module.css';

export function TopBar() {
  const { route, navigate } = useNavigation();
  const { user, theme, profiles, selectProfile } = useSession();
  const { balance, wheel, naming } = useGame();
  const fullscreen = useFullscreen();
  const definition = routeChrome(route, wheel, naming, theme);

  return (
    <header className={styles.bar}>
      <div className={styles.titles}>
        <h1 className={styles.title}>{definition.title}</h1>
        <span className={styles.subtitle}>{definition.subtitle}</span>
      </div>

      <div className={styles.right}>
        {/* The way back to the realm choice. The button on the profile page
            still exists, but a player who picked the wrong creator looks for
            the exit here, on every page, not buried in a sub-panel. Shown only
            when there is a second realm to switch to. */}
        {profiles.length > 1 && (
          <button
            type="button"
            className={styles.iconButton}
            onClick={() => selectProfile(null)}
            aria-label="Switch realm"
            title="Switch realm"
          >
            <Icon name="swap" size={17} />
          </button>
        )}

        {fullscreen.supported && (
          <button
            type="button"
            className={styles.iconButton}
            onClick={fullscreen.toggle}
            aria-pressed={fullscreen.active}
            aria-label={fullscreen.active ? 'Leave fullscreen' : 'Go fullscreen'}
            title={fullscreen.active ? 'Leave fullscreen' : 'Fullscreen'}
          >
            <Icon name={fullscreen.active ? 'collapse' : 'expand'} size={17} />
          </button>
        )}

        <button
          type="button"
          className={styles.credits}
          onClick={() => navigate('wheel')}
          aria-label={`Your ${creditWord(naming)} balance`}
        >
          <span className={styles.creditsIcon}>
            <Icon name={creditIconFor(theme)} size={15} />
          </span>
          {formatCredits(balance)}
        </button>

        {user && (
          <button type="button" className={styles.user} onClick={() => navigate('profile')}>
            <Avatar userId={user.id} avatarHash={user.avatar} name={user.displayName} size={28} />
            <span className={styles.userName}>{user.displayName}</span>
          </button>
        )}
      </div>
    </header>
  );
}
